import { useMutation } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
export const useCreateFiles = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    return useMutation(input => client.media.uploadFiles(input, useMutationOptions === null || useMutationOptions === void 0 ? void 0 : useMutationOptions.onError), {
        ...useMutationOptions,
        onError: useMutationOptions === null || useMutationOptions === void 0 ? void 0 : useMutationOptions.onError,
    });
};
//# sourceMappingURL=useCreateFiles.js.map